export const getMenuItems = (deliveryMethods = []) =>
  [...deliveryMethods]
    .sort((a, b) => (a.internal_id || 0) - (b.internal_id || 0))
    .map(dm => ({
      label: `${dm.internal_id} | ${dm.internal_name}`,
      value: dm.id,
    }))
